export default {
  // Loading and error states
  loading: 'Loading location...',
  fetchError: 'Failed to load location details',
  errorTitle: 'Error',
  notFound: 'Location not found',

  // Location details
  address: 'Address',
  building: 'Building',
  floor: 'Floor',
  room: 'Room',
  createdAt: 'Created',
  updatedAt: 'Updated',

  // Resources section
  resourcesInLocation: 'Resources in this location',
  resourcesDescription: 'Browse all resources stored at {{locationName}}',

  // Transactions tabs
  transactions: {
    resources: 'Resources',
    borrowings: 'Borrowings',
    consumptions: 'Consumptions',
    refills: 'Refills',
    resourcesInLocation: 'Resources in this location',
    borrowingsFromLocation: 'Borrowings from this location',
    consumptionsFromLocation: 'Consumptions from this location',
    refillsToLocation: 'Refills to this location'
  }
};
